(function () {
  'use strict';

  function initAboutPage(root) {
    if (!root || root.dataset.ntAboutReady === 'true' || !window.L) return;

    var mapElement = root.querySelector('[data-nt-about-map]');
    var dataElement = root.querySelector('[data-nt-about-partners]');
    if (!mapElement || !dataElement) return;

    var partners;
    try {
      partners = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    root.dataset.ntAboutReady = 'true';

    var lightbox = root.querySelector('[data-nt-about-lightbox]');
    var lightboxImage = lightbox ? lightbox.querySelector('img') : null;
    var lightboxClose = lightbox ? lightbox.querySelector('[data-nt-about-lightbox-close]') : null;
    var listButtons = Array.prototype.slice.call(root.querySelectorAll('[data-partner-index]'));
    var markers = [];
    var pendingMoveEnd = null;
    var desktopPointer = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
    var map = window.L.map(mapElement, {
      scrollWheelZoom: desktopPointer,
      zoomControl: false,
      attributionControl: true
    }).setView([30.2, -94], 4);

    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map);
    window.L.control.zoom({ position: 'bottomright' }).addTo(map);

    var markerIcon = window.L.icon({
      iconUrl: root.dataset.markerUrl,
      iconSize: [34, 46],
      iconAnchor: [17, 45],
      popupAnchor: [0, -40]
    });

    function setActive(index) {
      listButtons.forEach(function (button, buttonIndex) {
        var active = buttonIndex === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function openLightbox(partner) {
      if (!lightbox || !lightboxImage) return;
      lightboxImage.src = partner.photo;
      lightboxImage.alt = partner.name;
      lightbox.hidden = false;
      document.body.classList.add('nt-about-lightbox-open');
      if (lightboxClose) lightboxClose.focus();
    }

    function closeLightbox() {
      if (!lightbox || lightbox.hidden) return;
      lightbox.hidden = true;
      document.body.classList.remove('nt-about-lightbox-open');
      if (lightboxImage) {
        lightboxImage.src = '';
        lightboxImage.alt = '';
      }
    }

    function createPopup(partner) {
      var popup = document.createElement('div');
      popup.className = 'partner-popup';

      var image = document.createElement('img');
      image.src = partner.photo;
      image.alt = partner.name;
      image.loading = 'lazy';
      image.tabIndex = 0;
      image.setAttribute('role', 'button');
      image.setAttribute('aria-label', 'Enlarge photo of ' + partner.name);
      image.addEventListener('click', function () { openLightbox(partner); });
      image.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openLightbox(partner);
        }
      });

      var name = document.createElement('strong');
      name.textContent = partner.name;
      var address = document.createElement('small');
      address.textContent = 'Location: ' + partner.address;
      var collaboration = document.createElement('p');
      var label = document.createElement('b');
      label.textContent = 'Collaboration: ';
      collaboration.appendChild(label);
      collaboration.appendChild(document.createTextNode(partner.collaboration));

      popup.appendChild(image);
      popup.appendChild(name);
      popup.appendChild(address);
      popup.appendChild(collaboration);
      return popup;
    }

    partners.forEach(function (partner, index) {
      var marker = window.L.marker([partner.lat, partner.lng], { icon: markerIcon })
        .addTo(map)
        .bindPopup(createPopup(partner), { minWidth: 250, maxWidth: 270 });
      marker.on('click', function () { setActive(index); });
      markers.push(marker);
    });

    function selectPartner(index) {
      var partner = partners[index];
      var marker = markers[index];
      if (!partner || !marker) return;

      setActive(index);
      map.closePopup();
      if (pendingMoveEnd) {
        map.off('moveend', pendingMoveEnd);
        pendingMoveEnd = null;
      }
      var target = window.L.latLng(partner.lat, partner.lng);
      if (map.getCenter().distanceTo(target) < 500 && map.getZoom() === 8) {
        marker.openPopup();
        return;
      }
      pendingMoveEnd = function () {
        marker.openPopup();
        pendingMoveEnd = null;
      };
      map.once('moveend', pendingMoveEnd);
      map.flyTo(target, 8, { duration: 0.7 });
    }

    listButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        selectPartner(Number(button.dataset.partnerIndex));
      });
    });

    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
      });
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeLightbox();
    });

    window.setTimeout(function () { map.invalidateSize(); }, 80);
  }

  function boot() {
    var root = document.querySelector('.nt-about-app');
    if (!root) return;
    if (window.L) {
      initAboutPage(root);
      return;
    }
    window.setTimeout(boot, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
